import { buildResponsiveSize } from '@tvg/fuse-utils';
import styled from 'styled-components';
import { TypographyComponent } from '../../fuse-typography-element/src/typography';
import { styledPriceConfig } from './config';

const { styledSalePriceWrapperConfig } = styledPriceConfig;

const StyledPriceContainer = styled.div.attrs({
	className: 'fuse-price',
})``;

const getMarginByViewport = (viewport) => `
	margin-bottom: ${styledSalePriceWrapperConfig.marginBottom?.[viewport]};
`;

const setMarginBottom = (size) => {
	const [isResponsive, setViewportCss] = buildResponsiveSize(size);

	return isResponsive ? setViewportCss(getMarginByViewport) : getMarginByViewport(size);
};

const StyledSalePriceWrapper = styled.div.attrs({
	className: 'fuse-price__sale-price-wrapper',
})`
	${({ size }) => `
		${setMarginBottom(size)}
		display: flex;
		align-items: center;
		flex-wrap: wrap;
	`}
`;

const StyledBasicPrice = styled(TypographyComponent).attrs({
	className: 'fuse-price__basic-price',
	color: 'var(--color-global-black)',
})`
	color: ${({ prevPrice }) =>
		prevPrice ? `var(--color-universal-redMid)` : `var(--color-global-black)`};
	margin-right: var(--spacing-global-space2);
`;

const StyledSavePrice = styled(TypographyComponent).attrs({
	className: 'fuse-price__save-price',
	color: 'var(--color-universal-redMid)',
})`
	margin-bottom: 0px;
`;

const StyledPrevPrice = styled(TypographyComponent).attrs({
	className: 'fuse-price__prev-price',
	color: 'var(--color-global-black)',
})`
	text-decoration: line-through;
	margin-bottom: 0;
`;

export {
	StyledBasicPrice,
	StyledPrevPrice,
	StyledPriceContainer,
	StyledSalePriceWrapper,
	StyledSavePrice,
};
